export default __webpack_public_path__ + "static/burring-d5844a384adee311bcbf89ff1db02e0f.png";